export default "__VITE_ASSET__DLG0Jfn___"